import { Config } from '@/features/config/schema/Config'
import axios from 'axios'

export async function getConfig(): Promise<Config> {
  const response = await axios.get(`/config.json`, {
    baseURL: globalThis.location.origin
  })
  return response.data
}
